import React from "react";
import { Link } from "react-router-dom";
import { APP_NAME } from "../lib/brand.js";

/**
 * Wordmark — the app's name, drawn one way everywhere.
 *
 * Nine pages each carried their own copy of the dot-plus-name markup, which
 * is how the name ended up saying "Vizette" on some and "Vizette for DSPs" on
 * others. One component means one name, one size, one place to change it.
 *
 * `to` makes it a link — conventionally to the person's own home, so the mark
 * doubles as "take me back". `small` is the breadcrumb variant.
 */
export default function Wordmark({ to, small = false }) {
  const style = small ? s.small : s.mark;
  const inner = (
    <>
      <span style={small ? s.dotSmall : s.dot} aria-hidden="true" />
      {APP_NAME}
    </>
  );
  return to
    ? <Link to={to} style={{ ...style, textDecoration: "none" }} aria-label={`${APP_NAME} home`}>{inner}</Link>
    : <span style={style}>{inner}</span>;
}

const s = {
  mark:     { fontWeight: "var(--weight-medium)", fontSize: 17, letterSpacing: "-0.3px", color: "var(--color-text-primary)", display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" },
  small:    { fontWeight: "var(--weight-medium)", fontSize: 13, letterSpacing: "-0.2px", color: "var(--color-text-secondary)", display: "inline-flex", alignItems: "center", gap: 5, whiteSpace: "nowrap" },
  dot:      { display: "inline-block", width: 8, height: 8, borderRadius: "50%", background: "var(--color-accent)" },
  dotSmall: { display: "inline-block", width: 6, height: 6, borderRadius: "50%", background: "var(--color-accent)" },
};
